import React,{useState} from 'react'
import FBLogin from 'react-facebook-login';
import "../CSS/Template/FbLogin.css"
import FooTer from "../Template/footer"


export default function FacebookLogin() {
    const [NameFb, setName] = useState("")
    const [ImgageFb, setImg] = useState("")

    let responseFacebook = (response) => {
        console.log(response)
        setName("Hello" +  response.name)
        setImg(response.picture.data.url)
    }
    return (
        <>
            <div className='fbContainer'>
                <h1 id='mainH1'>Welcome To Login Page</h1>
                <div className="fbDesign">
                    <h1 id='hd1'>{NameFb}</h1><br />
                    <img src={ImgageFb} alt="loading" />
                    <FBLogin
                        appId="614097610286833"
                        autoLoad={true}
                        fields="name,email,picture"
                        callback={responseFacebook} />
                </div>
            </div>
            <FooTer />
        </>
    )
}
